import { Outlet } from 'react-router';

/** Fleet page shell. Width follows the platform Helpdesk container. */
export function FleetLayout() {
  return (
    <div className="w-full min-w-0 space-y-6">
      <Outlet />
    </div>
  );
}
